"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _StyledTable = _interopRequireDefault(require("../../components/StyledTable"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead/TableHead"));
var _StyledTableRow = _interopRequireDefault(require("../../components/StyledTableRow"));
var _StyledTableCell = _interopRequireDefault(require("../../components/StyledTableCell"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody/TableBody"));
var _theme = require("../../theme");
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
var localizationMaps = _interopRequireWildcard(require("../../localization/maps"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var statusMap = {
  0: 'Pending',
  1: 'Active',
  2: 'Account Disabled',
  3: 'Parental Leave',
  4: 'Leave of Absence',
  5: 'Temporary Lay Off',
  6: 'Disability',
  7: 'Strike',
  8: 'Late Applicant',
  9: 'Terminated',
  10: 'Approved Leave',
  11: 'Survivor Benefits',
  12: 'Severance'
};

/**
 * @param number
 * @returns {string}
 * @private
 */
var _formatNumber = function _formatNumber(number) {
  return "$".concat((number || 0).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
};

/**
 * @param census
 * @param onSelectUser
 * @param classData
 * @param divisions
 * @param styles
 * @returns {*}
 * @constructor
 */
var CensusTable = function CensusTable(_ref) {
  var census = _ref.census,
    onSelectUser = _ref.onSelectUser,
    classData = _ref.classData,
    divisions = _ref.divisions;
  var styles = {
    scrollbar: {
      scrollbar: {
        '&::-webkit-scrollbar': {
          height: '15px',
          width: '15px'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: _theme.colors.surface,
          borderRadius: '10px',
          boxShadow: 'inset 0 0 2px rgba(0, 0, 0, .5)'
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: _theme.colors.backgroundGrey,
          borderRadius: '10px',
          boxShadow: 'inset 0 0 2px rgba(0, 0, 0, 0.2)'
        }
      }
    },
    tableHeading: {
      fontFamily: _theme.fonts.type.medium
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, styles.scrollbar), {}, {
      overflow: "auto",
      maxHeight: 600
    })
  }, /*#__PURE__*/_react["default"].createElement(_StyledTable["default"], null, /*#__PURE__*/_react["default"].createElement(_TableHead["default"], null, /*#__PURE__*/_react["default"].createElement(_StyledTableRow["default"], null, /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
    style: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.name)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
    style: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.status)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
    style: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.email)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
    style: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.birthdate)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
    style: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.employees["class"])), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
    style: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.employees.division)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
    style: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.employees.hireDate)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
    style: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.gender)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
    style: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.employees.occupation)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
    style: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.planDesign.coverage)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
    style: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.province)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
    style: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.census.earnings)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
    style: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.employees.payrollID)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
    style: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.signup.language)))), /*#__PURE__*/_react["default"].createElement(_TableBody["default"], null, census.map(function (user) {
    var className = null;
    if (classData[user.classID]) {
      className = classData[user.classID].title;
    }

    // find and set the division name
    var divisionName = null;
    if (divisions[user.divisionID]) {
      divisionName = divisions[user.divisionID].title;
    }
    user.salary = Number(user.salary);
    user.hourlyWage = Number(user.hourlyWage);
    user.hoursPerWeek = Number(user.hoursPerWeek);
    var name = user.firstname ? "".concat(user.firstname, " ").concat(user.lastname) : null;
    var birthdate = user.birthdate ? dates.getUTC(user.birthdate, 'll') : null;
    var hireDate = user.hireDate ? dates.getUTC(user.hireDate, 'll') : null;
    var earnings = user.salary !== 0 ? user.salary : user.hourlyWage * user.hoursPerWeek * 52;
    var status = statusMap[user.status];
    var coverageType = user.coverageType;
    return /*#__PURE__*/_react["default"].createElement(_StyledTableRow["default"], {
      key: user.userID,
      hover: true,
      onClick: function onClick() {
        return onSelectUser(user);
      }
    }, /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], null, name), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], null, localizationMaps.fromEnglish("memberStatuses", status)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], null, user.email), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], null, birthdate), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], null, className), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], null, divisionName), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], null, hireDate), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], null, localizationMaps.fromEnglish("genders", user.gender) || null), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], null, user.title), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], null, localizationMaps.fromEnglish("coverageTypes", coverageType)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], null, localizationMaps.fromEnglish("provinces", user.province)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], null, _formatNumber(earnings)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], null, user.payrollID), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], null, user.language));
  }))));
};
var _default = exports["default"] = CensusTable;